// extracted by mini-css-extract-plugin
export default {"errorUI":"Error_errorUI__h+a4M"};